<template>
  <v-menu
    :model-value="openMenu"
    max-width="400"
    location="right center"
    :close-on-content-click="false"
    @click:outside="openMenu = false"
  >
    <template v-slot:activator="{ props: activatorProps }">
      <div v-bind="activatorProps" @click="openMenu = !openMenu">
        <slot></slot>
      </div>
    </template>
    <template v-slot:default>
      <v-card class="ml-2 pa-3" width="250">
        <div class="d-flex pb-4 justify-center align-center position-relative">
          <span class="text-h7 pt-2 font-weight-bold">Data Type</span>
          <v-btn
            variant="text"
            size="small"
            icon="mdi-close"
            class="close-button"
            @click="openMenu = false"
          />
        </div>

        <v-list>
          <v-list-item
            density="compact"
            @click="onSelectDataType(DataType.STRING)"
            :disabled="store.state.isWorkflowDisabled"
            :class="{ 'selected-item': props.currentDataType === DataType.STRING }"
          >
            <v-list-item-title class="d-flex align-center ga-2">
              <v-icon size="small" color="#787878">mdi-format-letter-case</v-icon>
              String
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            density="compact"
            @click="onSelectDataType(DataType.NUMBER)"
            :disabled="store.state.isWorkflowDisabled"
            :class="{ 'selected-item': props.currentDataType === DataType.NUMBER }"
          >
            <v-list-item-title class="d-flex align-center ga-2">
              <v-icon size="small" color="#787878">mdi-numeric</v-icon>
              Number
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            density="compact"
            @click="onSelectDataType(DataType.BOOLEAN)"
            :disabled="store.state.isWorkflowDisabled"
            :class="{ 'selected-item': props.currentDataType === DataType.BOOLEAN }"
          >
            <v-list-item-title class="d-flex align-center ga-2">
              <v-icon size="small" color="#787878">mdi-toggle-switch</v-icon>
              Boolean
            </v-list-item-title>
          </v-list-item>
          <v-divider class="my-2"></v-divider>
          <v-list-item
            density="compact"
            @click="onSelectDataType(DataType.OBJECT)"
            :disabled="store.state.isWorkflowDisabled"
            :class="{ 'selected-item': props.currentDataType === DataType.OBJECT }"
          >
            <v-list-item-title class="d-flex align-center ga-2">
              <v-icon size="small" color="#787878">mdi-code-json</v-icon>
              Object
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-card>
    </template>
  </v-menu>
</template>

<script setup>
import { ref, watch } from 'vue'
import { useStore } from 'vuex'
import { DataType } from '@/constants/schema'

const props = defineProps({
  currentDataType: String
})

const emit = defineEmits(['onSelectDataType', 'update:menuOpen'])

const store = useStore()
const openMenu = ref(false)

watch(openMenu, (newValue) => {
  emit('update:menuOpen', newValue)
})

const onSelectDataType = (dataType) => {
  emit('onSelectDataType', dataType)
  openMenu.value = false
}
</script>

<style scoped>
.close-button {
  position: absolute;
  right: 0;
  top: 16px;
  transform: translateY(-50%);
}

.v-list-item {
  cursor: pointer;
}

.v-list-item:hover {
  background-color: rgba(0, 0, 0, 0.04);
}

:deep(.v-list-item.selected-item) {
  background-color: rgb(224, 224, 224) !important;
}

.selected-item {
  background-color: rgb(224, 224, 224) !important;
}

[data-theme="dark"] :deep(.v-list-item.selected-item),
[data-theme="dark"] .selected-item {
  background-color: var(--light-4) !important;
}
</style>
